// MODIFIED
import React from "react";
import DTRCorrectionPage from "../../v2/pages/Transactions/DTRCorrectionPage";

/**
 * Legacy Wrapper for Change Schedule Module.
 * Redirects to the V2 implementation to maintain App.js compatibility.
 */
function DTRCorrection({ user, userAccess, isHideSideMenu }) {
  return (
    <DTRCorrectionPage
      user={user} 
      userAccess={userAccess} 
      isHideSideMenu={isHideSideMenu} 
    />
  );
}

export default DTRCorrection;